import { Selector, State } from "./types";
import { match } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isConstrainElementsRequestFailure(constraint) {
      const req = getState().find((req) => match(req.constraint, constraint));

      return req ? req.request.isFailure : false;
    },
    isConstrainElementsRequestPending(constraint) {
      const req = getState().find((req) => match(req.constraint, constraint));

      return req ? req.request.isPending : false;
    },
    isConstrainElementsRequestSuccess(constraint) {
      const req = getState().find((req) => match(req.constraint, constraint));

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
